import { Meta } from 'models/Meta';
import { Order } from 'models/Order';

export const showOrderCount = (meta: Meta | undefined) => {
    if (meta) {
        return meta.max;
    } else {
        return 0;
    }
};

export const fulfilledThisMonth = (orders: Order[] | undefined) => {
    if (orders) {
        const thisMonth = orders.filter((date) => date.createdAt.slice(0, 7) === new Date().toISOString().slice(0, 7));
        return thisMonth.length;
    } else {
        return 0;
    }
};
